/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { Action, combineReducers, Reducer } from '@reduxjs/toolkit';
import { initialState as userDetailInitialState } from './authentication/user_detail';
import { initialState as filterInitialState } from './filter/filterSlice';
import { initialState as AuthInitialState } from './authentication/authentication.slice';
import { initialState as GlobalInitialState } from './global/global.slice';

export interface IReducers {
    [key: string]: Reducer;
}
function createInjectedReducer(staticReducers: IReducers = {}, injectedReducers: IReducers = {}) {
    // Initially we don't have any injectedReducers, so returning identity function to avoid the error
    if (Object.keys(injectedReducers).length === 0 && Object.keys(staticReducers).length === 0) {
        return (state: any) => state;
    } else {
        return combineReducers({
            ...staticReducers,
            ...injectedReducers,
        });
    }
}

const createResettableRootReducer = (rootReducer: any) => (state: any, action: Action) => {
    if (action.type === 'authentication/logout') {
        return rootReducer(
            {
                configuration: state.configuration,
                userDetail: { ...state.userDetail, ...userDetailInitialState },
                filter: { ...state.filter, ...filterInitialState },
                authentication: { ...state.authentication, ...AuthInitialState },
                widget: { ...state.widget },
                global: { ...GlobalInitialState, taffiStoreId: state.global.taffiStoreId },
            },
            action,
        );
    }
    return rootReducer(state, action);
};

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export const createReducer =
    (staticReducers: any = {}) =>
        (injectedReducers: any = {}) => {
            const rootReducer = createInjectedReducer(staticReducers, injectedReducers);
            const resettableRootReducer = createResettableRootReducer(rootReducer);
            return resettableRootReducer;
        };
